import React from 'react';
import { Tabs } from 'antd';
import { BlueLayout, PagesContainerUI, TabsContainer } from '../../styles/styled';
import NmsArchiveComponent from './components/NmsArchiveComponent';
import NmsMaterialsComponent from './components/NmsMaterialsComponent';

const { TabPane } = Tabs;
export const NmsMeetingPage = () => {
  return (
    <PagesContainerUI>
      <BlueLayout>Заседания НМС</BlueLayout>
      <TabsContainer white>
        <Tabs type="card" tabBarGutter={0}>
          <TabPane tab="Материалы" key="1">
            <NmsMaterialsComponent />
          </TabPane>
          <TabPane tab="Архив" key="2">
            <NmsArchiveComponent />
          </TabPane>
        </Tabs>
      </TabsContainer>
    </PagesContainerUI>
  );
};
